export const ctr = (click, sent) => {
  if (!sent) {
    return NaN;
  } else {
    return ` ${((click / sent) * 100).toFixed(2)} % `;
  }
};
